import { ValidatorResult } from '@onrunning/backstage-models';
import { type PaymentMethodArray } from '../models/payments.model';
import { CrudService } from './crud.service';

export class PaymentsService {
  private crudService: CrudService<any>;

  constructor() {
    this.crudService = new CrudService<any>('payments');
  }

  public getPaymentMethods(accountId: string): Promise<ValidatorResult<PaymentMethodArray>> {
    return this.crudService.do('get', `paymentMethods?accountId=${accountId}`, 'silent');
  }

  public checkout(accountId: string, data: any): Promise<ValidatorResult<any>> {
    return this.crudService.do('post', `checkout?accountId=${accountId}`, data, undefined, 'silent');
  }

  public checkoutDetails(accountId: string, data: any): Promise<ValidatorResult<any>> {
    return this.crudService.do('post', `checkoutDetails?accountId=${accountId}`, data, undefined, 'automatic');
  }
}
